import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import api from '../../../api/stoty'
import { setAudioData } from '../../../modules/audio/actions'
import PlaybackButton from './components/PlayBtn'
import TimeBar from './components/TimeBar'
import useAudio from './components/useAudio'
import LoginModal from './components/LoginModal'
import c from 'classnames'
import './index.scss'

const Audio = ({ audio, setPlayAudio, playAudio, idCard, play, setPlay, setSrcAudio, srcAudio, podcastData, checkedPodcast }) => {
  const [openLogin, setOpenLogin] = useState(false)
  const [playbackStatus, setPlaybackStatus] = useState('pause')
  const { user } = useSelector(({ session }) => session)
  const { audioState } = useSelector(({ audio }) => audio)
  const [audioElement, audioProps] = useAudio(audio, playbackStatus, setPlaybackStatus, setPlay)
  const dispatch = useDispatch()

  const onPlyaPodcast = () => {
    api.getCountListenPodcast()
      .then(res => {
        if (res?.data?.count >= 3 && !user?.accessKey && audioState?.src !== audio) {
          setOpenLogin(true)
        } else {
          if (audioState?.src === audio) {
            dispatch(setAudioData({ ...audioState, src: audio, status: !audioState?.status, active: false, podcast: { ...podcastData } }))
          } else {
            dispatch(setAudioData({ time: 0, newTime: null, src: audio, status: true, active: false, progress: 0, duration: null, podcast: { ...podcastData } }))
          }
        }
      })
      .catch(error => console.error(error))
  }

  return (
    <>
      <LoginModal open={openLogin} setOpen={setOpenLogin} onSignUp />

      <div className={c('customAudioPanel', audioState?.status && audioState?.src === audio && 'backgCustomAudioPanel')}>
        {audioElement}

        <PlaybackButton
          play={play}
          setPlay={setPlay}
          checkedPodcast={checkedPodcast}
          idCard={idCard}
          setPlayAudio={setPlayAudio}
          podcastData={podcastData}
          onClick={onPlyaPodcast}
          playbackStatus={playbackStatus}
          progress={audioProps.progress}
          playAudio={playAudio}
          audio={audio}
          audioProps={audioProps}
          setPlaybackStatus={setPlaybackStatus}
          srcAudio={srcAudio}
        />

        <TimeBar
          currentTime={audioProps.currentTime}
          isSeeking={audioProps.isSeeking}
          duration={audioProps.duration}
          progress={audioProps.progress}
          setTime={audioProps.setTime}
          playAudio={playAudio}
          audio={audio}
        />
      </div>
    </>
  )
}

export default Audio
